import React, { useState, Fragment } from "react";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import TableComponent from "../../../shared/components/table";
import { PanelCaseFolderColumns } from "../../../shared/components/table/columns/panelCaseFolderColumns";

import { SortingState } from "@tanstack/react-table";
import { Menu, Transition } from "@headlessui/react";
import { FILTER, ARROW_LEFT } from "../../../assets";
import RecusalRequestModal, {
  ReasonForRefusalModal,
  RecusalDeclinedSuccessModal,
} from "../president/case-folder/modals/RecusalRequestModal";
import { ReasonForRecallModal } from "./case-folder/modals/RecusalRequestModal";
import SuccessModalV2 from "../../../shared/components/successModal/sucessModalV2";
import WarningPromptModal from "../registrar2/case-folder/modals/WarningPromptModal";

const topTabs = ["All cases", "History"];
const historyTabs = ["Recused", "Recalled", "Concluded"];

const FILTER_OPTIONS = ["All cases", "Pending cases", "Completed cases"];

const CaseFolders = () => {
  const [activeTopTab, setActiveTopTab] = useState("All cases");
  const [activeHistoryTab, setActiveHistoryTab] = useState("Recused");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All cases");
  const [showRecusalModal, setShowRecusalModal] = useState(false);
  const [showRecusalSuccess, setShowRecusalSuccess] = useState(false);
  const [showRefusalModal, setShowRefusalModal] = useState(false);
  const [showRefusalSuccess, setShowRefusalSuccess] = useState(false);
  const [showRequestRecusalModal, setShowRequestRecusalModal] = useState(false);
  const [showRequestRecusalSuccess, setShowRequestRecusalSuccess] =
    useState(false);
  const [showRecallReasonModal, setShowRecallReasonModal] = useState(false);
  const [showRecallAcceptPrompt, setShowRecallAcceptPrompt] = useState(false);
  const [showRecallAcceptSuccess, setShowRecallAcceptSuccess] = useState(false);
  const [showRecallRefusalModal, setShowRecallRefusalModal] = useState(false);
  const [showRecallDeclinedSuccess, setShowRecallDeclinedSuccess] =
    useState(false);
  const [showDppAdviceModal, setShowDppAdviceModal] = useState(false);
  const [showDppAdviceSuccess, setShowDppAdviceSuccess] = useState(false);
  const [showConcludeWarningOne, setShowConcludeWarningOne] = useState(false);
  const [showConcludeWarningTwo, setShowConcludeWarningTwo] = useState(false);
  const [showConcludeSuccess, setShowConcludeSuccess] = useState(false);

  const handleViewRecusalRequest = () => {
    setShowRecusalModal(true);
  };

  const handleApproveRecusal = () => {
    setShowRecusalModal(false);
    setShowRecusalSuccess(true);
  };

  const handleDeclineRecusal = () => {
    setShowRecusalModal(false);
    setShowRefusalModal(true);
  };

  const handleSubmitRefusal = () => {
    setShowRefusalModal(false);
    setShowRefusalSuccess(true);
  };

  const handleOpenRequestRecusal = () => {
    setShowRequestRecusalModal(true);
  };

  const handleSubmitRequestRecusal = () => {
    setShowRequestRecusalModal(false);
    setShowRequestRecusalSuccess(true);
  };

  const handleOpenDppAdvice = () => {
    setShowDppAdviceModal(true);
  };

  const handleSubmitDppAdvice = () => {
    setShowDppAdviceModal(false);
    setShowDppAdviceSuccess(true);
  };

  const handleOpenConcludeCase = () => {
    setShowConcludeWarningOne(true);
  };

  const handleConfirmConcludeWarningOne = () => {
    setShowConcludeWarningOne(false);
    setShowConcludeWarningTwo(true);
  };

  const handleConfirmConcludeWarningTwo = () => {
    setShowConcludeWarningTwo(false);
    setShowConcludeSuccess(true);
  };

  const handleOpenRecallReason = () => {
    setShowRecallReasonModal(true);
  };

  const handleAcceptRecallFromReason = () => {
    setShowRecallReasonModal(false);
    setShowRecallAcceptPrompt(true);
  };

  const handleConfirmAcceptRecall = () => {
    setShowRecallAcceptPrompt(false);
    setShowRecallAcceptSuccess(true);
  };

  const handleDeclineRecallFromReason = () => {
    setShowRecallReasonModal(false);
    setShowRecallRefusalModal(true);
  };

  const handleSubmitRecallRefusal = () => {
    setShowRecallRefusalModal(false);
    setShowRecallDeclinedSuccess(true);
  };

  const mockData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      requests: "Recall request",
      status: "Ongoing",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      requests: "",
      status: "Ongoing",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      requests: "",
      status: "Ongoing",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      requests: "",
      status: "Ongoing",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      requests: "",
      status: "Ongoing",
    },
  ];

  const panelData = [
    {
      sn: 1,
      panel_name: "Panel A",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 2",
      subject_matter: "Criminal",
      status: "Active",
      docket: "",
    },
    {
      sn: 2,
      panel_name: "Panel B",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 3",
      subject_matter: "Civil",
      status: "Active",
      docket: "",
    },
    {
      sn: 3,
      panel_name: "Panel C",
      judges: [
        "Hon. Justice Esther Ochendo",
        "Hon. Justice Mba",
        "Hon. Justice Eze",
      ],
      admin: "Admin",
      court_number: "Court 4",
      subject_matter: "Civil",
      status: "Active",
      docket: "",
    },
  ];

  const historyRecusedData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recused",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recused",
    },
  ];

  const historyRecalledData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recalled",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Recalled",
    },
  ];

  const historyConcludedData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Concluded",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      details: "View",
      status: "Concluded",
    },
  ];

  const getActiveHistoryData = () => {
    if (activeHistoryTab === "Recalled") return historyRecalledData;
    if (activeHistoryTab === "Concluded") return historyConcludedData;
    return historyRecusedData;
  };

  const filteredHistoryData = getActiveHistoryData().filter((row) => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    return (
      row.date.toLowerCase().includes(term) ||
      row.title.toLowerCase().includes(term) ||
      row.appeal_number.toLowerCase().includes(term) ||
      row.status.toLowerCase().includes(term)
    );
  });

  return (
    <div className="flex flex-col h-full min-h-screen ">
      <div className="bg-white px-8 pt-6 pb-0 border-b border-[#E9EAEB]">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-[28px] font-bold text-[#1A1A1A]">Case folder</h1>
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="flex items-center gap-x-2 px-4 py-2 border border-[#D0D5DD] rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 bg-white shadow-sm transition-colors">
              <img src={FILTER} alt="filter" className="w-4 h-4" />
              <span>{selectedFilter}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 py-1">
                <div className="px-1 py-1">
                  {FILTER_OPTIONS.map((option) => (
                    <Menu.Item key={option}>
                      {({ active }) => (
                        <button
                          onClick={() => setSelectedFilter(option)}
                          className={`${
                            active
                              ? "bg-gray-50 text-[#1A1A1A]"
                              : "text-[#344054]"
                          } group flex w-full items-center rounded-md px-3 py-2 text-sm font-medium`}
                        >
                          {option}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
        <div className="flex items-center gap-x-2 text-sm text-[#464255] mb-4">
          <Link to="/panel/overview" className="hover:text-[#00B074]">
            Home
          </Link>
          <img src={ARROW_LEFT} alt="arrow" className="w-3 h-3" />
          <span className="font-medium text-[#1A1A1A]">Case folder</span>
        </div>
      </div>

      <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
        <div className="flex items-center gap-8 text-sm font-medium">
          {topTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTopTab(tab)}
              className={`pb-3 border-b-2 ${
                activeTopTab === tab
                  ? "border-[#111827] text-[#111827]"
                  : "border-transparent text-[#667085]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Search, filter, and table */}
      {activeTopTab === "All cases" && (
        <>
          <div className="px-8 py-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <div className="relative w-full max-w-[320px]">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] bg-white text-sm placeholder:text-[#667085] shadow-sm"
                />
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
              </div>
            </div>
          </div>

          <div className="flex-1 px-8 pb-10">
            <div className="bg-white rounded-2xl">
              <TableComponent
                DATA={mockData}
                // @ts-ignore
                COLUMNS={PanelCaseFolderColumns(
                  handleOpenRequestRecusal,
                  handleOpenRecallReason,
                  handleOpenDppAdvice,
                  handleOpenConcludeCase,
                )}
                sorting={sorting}
                setSorting={setSorting}
              />

              <div className="flex items-center justify-between px-6 py-4 border-t border-[#E4E7EC] text-sm text-[#667085]">
                <div className="flex items-center gap-2">
                  <span>
                    Page <span className="font-medium">1</span> of{" "}
                    <span className="font-medium">10</span>
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                      Previous
                    </button>
                    <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                      Next
                    </button>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Entries per page:</span>
                    <select className="border border-[#D0D5DD] rounded-lg px-2 py-1 bg-white focus:outline-none text-sm">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {activeTopTab === "History" && (
        <>
          <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
            <div className="flex items-center gap-8 text-sm font-medium">
              {historyTabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveHistoryTab(tab)}
                  className={`pb-3 border-b-2 ${
                    activeHistoryTab === tab
                      ? "border-[#111827] text-[#111827]"
                      : "border-transparent text-[#667085]"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          <div className="px-8 py-6 flex flex-col gap-4">
            <div className="relative w-full max-w-[320px]">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] bg-white text-sm placeholder:text-[#667085] shadow-sm"
              />
              <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
            </div>
          </div>

          <div className="flex-1 px-8 pb-10">
            <div className="bg-white rounded-2xl border border-[#E5E7EB]">
              <TableComponent
                DATA={filteredHistoryData}
                // @ts-ignore
                COLUMNS={PanelCaseHistoryColumns}
                sorting={sorting}
                setSorting={setSorting}
              />
            </div>
          </div>
        </>
      )}
      <RecusalRequestModal
        isOpen={showRecusalModal}
        onClose={() => setShowRecusalModal(false)}
        onApprove={handleApproveRecusal}
        onDecline={handleDeclineRecusal}
      />
      <SuccessModalV2
        open={showRecusalSuccess}
        close={() => setShowRecusalSuccess(false)}
        message="Recusal request approved!"
      />
      <ReasonForRefusalModal
        isOpen={showRefusalModal}
        onClose={() => setShowRefusalModal(false)}
        onSubmit={handleSubmitRefusal}
      />
      <RecusalDeclinedSuccessModal
        isOpen={showRefusalSuccess}
        onClose={() => setShowRefusalSuccess(false)}
      />
      <ReasonForRefusalModal
        isOpen={showRequestRecusalModal}
        onClose={() => setShowRequestRecusalModal(false)}
        onSubmit={handleSubmitRequestRecusal}
      />
      <SuccessModalV2
        open={showRequestRecusalSuccess}
        close={() => setShowRequestRecusalSuccess(false)}
        message="Request submitted"
      />
      <ReasonForRefusalModal
        isOpen={showDppAdviceModal}
        onClose={() => setShowDppAdviceModal(false)}
        onSubmit={handleSubmitDppAdvice}
        title="Request DPP advice"
      />
      <SuccessModalV2
        open={showDppAdviceSuccess}
        close={() => setShowDppAdviceSuccess(false)}
        message="DPP advice request submitted"
      />
      <ReasonForRecallModal
        isOpen={showRecallReasonModal}
        onClose={() => setShowRecallReasonModal(false)}
        onAccept={handleAcceptRecallFromReason}
        onDecline={handleDeclineRecallFromReason}
      />
      <WarningPromptModal
        isOpen={showRecallAcceptPrompt}
        onClose={() => setShowRecallAcceptPrompt(false)}
        message="Are you sure you want to accept this request?"
        onClick={handleConfirmAcceptRecall}
      />
      <SuccessModalV2
        open={showRecallAcceptSuccess}
        close={() => setShowRecallAcceptSuccess(false)}
        message="Recall accepted successfully  "
      />
      <ReasonForRefusalModal
        isOpen={showRecallRefusalModal}
        onClose={() => setShowRecallRefusalModal(false)}
        onSubmit={handleSubmitRecallRefusal}
      />
      <SuccessModalV2
        open={showRecallDeclinedSuccess}
        close={() => setShowRecallDeclinedSuccess(false)}
        message="Recall request declined"
      />
      <WarningPromptModal
        isOpen={showConcludeWarningOne}
        onClose={() => setShowConcludeWarningOne(false)}
        message="You are about closed this case. Ensure that judgement or a ruling has been entered in this case."
        onClick={handleConfirmConcludeWarningOne}
      />
      <WarningPromptModal
        isOpen={showConcludeWarningTwo}
        onClose={() => setShowConcludeWarningTwo(false)}
        message="Are you sure you want to complete this action?"
        onClick={handleConfirmConcludeWarningTwo}
      />
      <SuccessModalV2
        open={showConcludeSuccess}
        close={() => setShowConcludeSuccess(false)}
        message="Case status updated successfully"
      />
    </div>
  );
};

export default CaseFolders;
